module.exports = __webpack_public_path__ + "img/工艺画-3.800b805c.jpg";